export const compareVersion = (version1: string, version2: string) => {
  //判断version1是否大于或等于version2，比较minor版本
  const version1Arr = version1.split('.').map(Number);
  const version2Arr = version2.split('.').map(Number);
  const length = Math.max(version1Arr.length, version2Arr.length);
  for (let i = 0; i < length; i++) {
    if (version1Arr[i] > version2Arr[i]) {
      return true;
    } else if (version1Arr[i] < version2Arr[i]) {
      return false;
    }
  }
  return true;
};
